import { Box, Grid, Card, CardContent, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

export default function PortfolioSkeleton() {
  return (
    <Box sx={{ p: 3 }}>
      
      {/* Top Cards */}
      <Grid container spacing={3}>
        {[1,2,3].map((item) => (
          <Grid item xs={12} md={4} key={item}>
            <Card
              sx={{
                background: "#1f2022ff",
                borderRadius: 3,
                border: "1px solid #ffffff0f"
              }}
            >
              <CardContent>

                <Skeleton variant="text" width={120} height={25} />

                <Skeleton
                  variant="text"
                  width={160}
                  height={50}
                  sx={{ mt: 1 }}
                />

                <Skeleton
                  variant="text"
                  width={80}
                  height={30}
                  sx={{ mt: 1 }}
                />

                <Skeleton
                  variant="rectangular"
                  height={1}
                  sx={{ my: 2 }}
                />

                <Skeleton width={140} height={20} />

                <Skeleton width={100} height={20} />

              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>


      {/* Table Section */}
      <Box
        sx={{
          mt: 4,
          p: 2,
          borderRadius: 3,
          border: "1px solid rgba(255,255,255,0.06)",
          background: "#1f2022ff"
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Skeleton width={40} />
              </TableCell>
              <TableCell>
                <Skeleton width={100} />
              </TableCell>
              <TableCell align="right">
                <Skeleton width={80} />
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {[1,2,3,4].map((row) => (
              <TableRow key={row}>
                <TableCell>
                  <Skeleton width={20} />
                </TableCell>
                <TableCell>
                  <Skeleton width={120} />
                </TableCell>
                <TableCell align="right">
                  <Skeleton width={60} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

    </Box>
  );
}